import * as React from 'react';
import { Step, Stepper, StepLabel, StepContent } from 'material-ui';
import { FormattedHTMLMessage } from 'react-intl';
import { bool, object, string } from 'prop-types';
import ArrowRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import { equals, path } from 'ramda';

import {
  StepperStyles,
  StepperLabelBar,
  StepperLabel,
  StepperLabelText,
  StepperLabelDescriptionText,
  StepperContentBar,
  StepperContent,
  StepperContentArea,
  StepperInsideContent,
} from './Stepper.less';
import { colors } from 'styles/provider';
import { fade } from 'material-ui/utils/colorManipulator';
import MakeStepperContent from '../StepContentProvider';
import { currentStep } from '../../utils';

const iconStyle = upcoming => ({
  color: upcoming ? colors.clrGray : colors.clrSecondary,
  width: '3rem',
  height: 'auto',
  padding: 0,
});

const labelBarStyle = upcoming => ({
  backgroundColor: upcoming ? colors.clrGray : fade(colors.clrSecondary, 0.25),
});

const labelStyle = upcoming => ({
  borderColor: upcoming ? colors.clrGray : colors.clrSecondary,
});

const contentBarStyle = upcoming => ({
  backgroundColor: upcoming ? colors.clrGray : fade(colors.clrSecondary, 0.25),
});

const StepLabelIconComponent = ({ active, upcoming }) => (
  <div style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
    <div className={StepperLabelBar} style={labelBarStyle(upcoming)} />
    {active ? <ArrowDown style={iconStyle(upcoming)} /> : <ArrowRight style={iconStyle(upcoming)} />}
  </div>
);

StepLabelIconComponent.propTypes = { active: bool, upcoming: bool };

const steps = [0 /** Intro */, 1, 2, 3, 4, 5, 6, 7, 8];

class OnlineRehabilitationStepper extends React.Component {
  state = {
    activeStep: null,
    context: {},
  };

  changeStep = step => {
    if (step || step === 0) this.setState({ activeStep: step });
  };
  changeContext = ctx => this.setState({ context: ctx });

  componentDidMount() {
    this.changeContext(this.context);
  }
  componentDidUpdate() {
    const { formValues } = this.context;
    const { documentData } = this.props;

    // Context will update after component has mounted. Check whether formValues have updated
    if (!equals(path(['context', 'formValues'], this.state), formValues)) {
      if (!this.state.activeStep) {
        // Get current step based on which sessions are completed
        // Change step first automatically based on progress
        this.changeStep(currentStep(documentData, this.props.hasDiaryBeenFilled));
        this.changeContext(this.context);
      }
    } else if (equals(formValues, {}) && this.state.activeStep === null) {
      // Set first step if new document
      this.changeStep(0);
    }
  }

  clickToChangeStep = step => {
    const isDev = __ENABLE_PROD_TESTING__; // Testing mode which allows selecting any step
    if (!isDev) {
      const { documentData } = this.props;
      const currentStepNow = currentStep(documentData, this.props.hasDiaryBeenFilled);
      if (step <= currentStepNow) {
        // Allow the patient to view previous sessions
        this.changeStep(step);
      }
    } else {
      // If developer/tester, allow changing of step whenever
      this.changeStep(step);
    }
  };

  render() {
    const { editingDocumentId, editedCommit, viewingId } = this.props;
    const fm = (id, values) => <FormattedHTMLMessage id={id} values={values} />;
    return (
      <div className={StepperStyles}>
        <Stepper activeStep={this.state.activeStep} orientation="vertical" connector={null}>
          {steps.map(s => (
            <Step key={s} onClick={() => this.clickToChangeStep(s)} style={{ margin: 0 }}>
              <StepLabel
                icon={
                  <StepLabelIconComponent
                    step={s}
                    active={this.state.activeStep === s}
                    upcoming={s > this.state.activeStep}
                  />
                }
                className={StepperLabel}
                style={labelStyle(s > this.state.activeStep)}
                iconContainerStyle={{ padding: 0 }}
              >
                <h2 className={StepperLabelText}>{fm(`onlineRehabilitation.steps.${s}`)}</h2>
                <span className={StepperLabelDescriptionText}>{fm(`onlineRehabilitation.steps.${s}.description`)}</span>
              </StepLabel>
              <StepContent className={StepperContent} transitionDuration={300}>
                <div className={StepperContentArea}>
                  <div className={StepperContentBar} style={contentBarStyle(s > this.state.activeStep)}>
                    &nbsp;
                  </div>

                  <div className={StepperInsideContent}>
                    <MakeStepperContent
                      step={s}
                      fm={fm}
                      changeStep={this.changeStep}
                      editingDocumentId={editingDocumentId}
                      viewingId={viewingId}
                      editedCommit={editedCommit}
                    />
                  </div>
                </div>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </div>
    );
  }
}

OnlineRehabilitationStepper.contextTypes = {
  formValues: object,
};
OnlineRehabilitationStepper.propTypes = {
  editingDocumentId: string,
  viewingId: string,
  editedCommit: object,
  hasDiaryBeenFilled: bool,
  documentData: object,
};

export default OnlineRehabilitationStepper;
